<ng-container *ngComponentOutlet="mapComponent; inputs: customDataBinding;" />
